import { coreCustomersCurrentGetAsyncSlice } from './get';

export const { receiveGetCoreCustomersCurrent, requestGetCoreCustomersCurrent, resetGetCoreCustomersCurrent } =
	coreCustomersCurrentGetAsyncSlice.asyncActionCreators;

export * from './feature-flags/actions';
